if(!customElements.get('login-form')){
    class LoginForm extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.buttonRecoverPassword = this.querySelector(".button-recover-password");
            this.buttonLogin = this.querySelector(".button-login");

            this.sectionLogin = this.querySelector('#login');
            this.sectionRecover = this.querySelector('#recover');

            if(this.buttonRecoverPassword){
                this.buttonRecoverPassword.addEventListener("click", this.updateId.bind(this));
            }

            if(this.buttonLogin){
                this.buttonLogin.addEventListener("click", this.updateId.bind(this));
            }
        }

        updateId(e){
            e.preventDefault();

            const href = e.currentTarget.getAttribute('href');
            const targetId = href.replace('#', '');
            const targetEl = this.querySelector(`#${targetId}`);
            if(!targetEl) return;

            setTimeout(() => {
                history.replaceState(null, '', href);

                targetEl.style.display = 'block';
                if(targetId === 'recover') this.sectionLogin.style.display = 'none';
                else if(targetId === 'login') this.sectionRecover.style.display = 'none';
            }, 0);
        }
    }

    customElements.define('login-form', LoginForm);
}